import React, { Component } from 'react';
import './Team.scss';

class Team extends Component {
  render() {
    return (
      <section id="teams" className="section teams">
        <div className="container">
          <div className="row person-container">
            <div className="col-md-3 col-sm-6">
              <div className="person">
                <img src="images/programmer.jpeg" alt="" className="img-responsive" />
                <div className="person-content">
                  <h4>Programmer</h4>
                  <h5 className="role">Project Manager</h5>
                  <p>Providing communication, planning and collaboration process</p>
                </div>
                <ul className="social-icons clearfix">
                  <li><a href="#"><span className="fa fa-facebook"></span></a></li>
                  <li><a href="#"><span className="fa fa-twitter"></span></a></li>
                  <li><a href="#"><span className="fa fa-linkedin"></span></a></li>
                  <li><a href="#"><span className="fa fa-google-plus"></span></a></li>
                  <li><a href="#"><span className="fa fa-dribbble"></span></a></li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="person">
                <img src="images/designer.png" alt="" className="img-responsive" />
                <div className="person-content">
                  <h4>Designer</h4>
                  <h5 className="role">3D Artist</h5>
                  <p>3D Modelling, Texturing, Animating</p>
                </div>
                <ul className="social-icons clearfix">
                  <li><a href="#" className=""><span className="fa fa-facebook"></span></a></li>
                  <li><a href="#" className=""><span className="fa fa-twitter"></span></a></li>
                  <li><a href="#" className=""><span className="fa fa-linkedin"></span></a></li>
                  <li><a href="#" className=""><span className="fa fa-google-plus"></span></a></li>
                  <li><a href="#" className=""><span className="fa fa-dribbble"></span></a></li>
                </ul>
              </div>
            </div>
            {/*<div className="col-md-3 col-sm-6">
                <div className="person">
                    <img src="images/team-3.jpg" alt="" className="img-responsive" />
                    <div className="person-content">
                        <h4>Victoria Valdez</h4>
                        <h5 className="role">UI Designer</h5>
                        <p>Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Maecenas sed diam eget risus varius blandit sit amet non magna. Nullam quis risus eget urna mollis ornare vel eu leo.</p>
                    </div>
                    <ul className="social-icons clearfix">
                        <li><a href="#" className=""><span className="fa fa-facebook"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-twitter"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-linkedin"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-google-plus"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-dribbble"></span></a></li>
                    </ul>
                </div>
            </div>
            <div className="col-md-3 col-sm-6">
                <div className="person">
                    <img src="images/team-4.jpg" alt="" className="img-responsive" />
                    <div className="person-content">
                        <h4>Beverly Little</h4>
                        <h5 className="role">Data Scientist</h5>
                        <p>Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Maecenas sed diam eget risus varius blandit sit amet non magna. Nullam quis risus eget urna mollis ornare vel eu leo.</p>
                    </div>
                    <ul className="social-icons clearfix">
                        <li><a href="#" className=""><span className="fa fa-facebook"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-twitter"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-linkedin"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-google-plus"></span></a></li>
                        <li><a href="#" className=""><span className="fa fa-dribbble"></span></a></li>
                    </ul>
                </div>
            </div>*/}
          </div>
        </div>
      </section>
    );
  }
}

export default Team;